import type { FC } from 'react';
import s from './UserInfoBulletList.scss';

interface Props {}
const UserInfoBulletList: FC<Props> = props => <ul className={s['root']} {...props} />;
UserInfoBulletList.displayName = 'UserInfoBulletList';

export default UserInfoBulletList;
